<h1 mat-dialog-title>Betrieb</h1>
<div mat-dialog-content>
    <vvvo-details
        #vvvoDetailsComp
        [kunde]="kunde"
        [isDialog]="true"
        [emailRequired]="emailRequired"
        (save)="dialogRef.close($event)"
    ></vvvo-details>
</div>
<div mat-dialog-actions style="display: flex">
    <button mat-flat-button color="accent" (click)="saveInDialog()" [disabled]="!vvvoDetailsComp?.allFormsValid()">Speichern</button>
    <span style="flex: 1 1 auto"></span>
    <button mat-button (click)="dialogRef.close()">Abbrechen</button>
</div>
